/*
 * @Author: your name
 * @Date: 2020-03-03 21:33:06
 * @LastEditTime: 2020-03-03 22:03:08
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js